'use client'

import styled from 'styled-components';
import { Input } from "antd";
import Label from "@/components/UI/Form/Label/Label";
import {getVariantStyles} from "@/components/UI/Form/Inputs/BaseInput/options/variant.options";
import {getColor} from "@/pipes/theme.pipe";

export const BaseInputWrapper = styled.div`
    width: 100%;
    min-width: 200px;
    position: relative;
    
    input {
        border-color: transparent;
            
        ${getVariantStyles}
    }
`

export const BaseInputLabel = styled(Label)``

export const InputFieldWrapper = styled.div`
    position: relative;
`

export const BaseInputStyled = styled(Input)`
    height: 40px;
        
    &:is(input), input {
        border-radius: 20px;
        padding-left: 25px;
    } 
        
    &:not(:disabled) {
        &:hover, &:active, &:focus-within {
            border-color: ${getColor('secondary', '300')} !important;
        }
    }
`